import { Injectable } from "@angular/core";

import { PageableResult } from "../../models/domains/paginator/pageable-result";
import { PagingRequest } from "../../models/domains/paginator/paging-request";
import { RemoteGatewayFactory } from "../../gateways/remote-gateway-factory";
import { BackendUrl } from "../../models/domains/urls/back-end.url";
import { SearchTherapeuticClassesByParser } from "../parsers/pbm/benefit/search-therapeutic-classes-by.parser";

@Injectable()
export class TherapeuticClassRepository {
  constructor(private remoteGatewayFactory: RemoteGatewayFactory, private searchTherapeuticClassesByParser: SearchTherapeuticClassesByParser) {}

  public async searchTherapeuticClassProductsBy(pagingRequest: PagingRequest): Promise<PageableResult> {
    const body = {
      StartIndex: pagingRequest.getStart(),
      TotalPerPages: pagingRequest.getEnd(),
      FilterText: pagingRequest.getFilterText(),
    };

    const headers = { "Content-Type": "application/json" };

    try {
      const remoteGateway = this.remoteGatewayFactory.createDefaultRemoteGateway();

      const backendUrl = new BackendUrl("/api/products/therapeutic-classes");

      const payload = await remoteGateway.postWithHeaders(backendUrl, body, headers);

      return this.searchTherapeuticClassesByParser.parse(payload);
    } catch (err) {
      return await Promise.reject(err);
    }
  }
}
